var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJizhonghezai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4795"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631343",
    x: 2.21875,
    y: 12.4069,
    width: 13.0625,
    height: 2.46811,
    fill: "#C2C2C2",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 687",
    d: "M8.75 0.5L8.75 10.398",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 13",
    d: "M8.74993 11.7396L6.96369 9.72725L10.5362 9.72725L8.74993 11.7396Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJizhonghezai);
export default __webpack_public_path__ + "static/media/jizhonghezai.23bba21e87bcad128db913e2cf713e78.svg";
export { ForwardRef as ReactComponent };